import React, { useEffect, useState } from "react";
import {
  btnStyle,
  managementInputStyle,
  managementModalStyle,
  StyledModal,
} from "pages/PatientOverview/styles";
import CloseIcon from "@mui/icons-material/Close";

import { Box, Grid, CircularProgress, Button } from "@mui/material";
import { PatientRepository } from "repositories/PatientRepository";
import TeamSelector from "pages/auth/TeamSelector";
type Props = {
  isEnabled: boolean;
  setIsEnabled: any;
  patientId: string;
  teamList: any[];
  patientTeams: string[];
  setCurrentTeams: any;
};

export const AssignTeamModal = ({
  isEnabled,
  setIsEnabled,
  patientId,
  teamList,
  patientTeams = [],
  setCurrentTeams,
}: Props) => {
  const [isError, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState(patientTeams);

  const onCloseResultModal = () => {
    setIsEnabled(false);
  };

  useEffect(() => {
    if (!teamList.length || !patientTeams.length) {
      return setSelectedTeams([]);
    }
    const selectedTeams = teamList.filter((team) =>
      patientTeams.includes(team._id)
    );
    setSelectedTeams(selectedTeams);
  }, [teamList]);

  return (
    <StyledModal
      onClick={(e) => {
        e.stopPropagation();
      }}
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={isEnabled}
    >
      <Box
        sx={{
          ...managementModalStyle,
          minHeight: `250px`,
          height: "auto",
        }}
      >
        <>
          <Grid container mt={1} mb={1}>
            <Grid item xs={12} sx={{ fontWeight: "700", fontSize: 16 }}>
              {"Select a Team to Assign to the Athlete"}
            </Grid>
            <TeamSelector
              customWidth="100%"
              selectedTeams={selectedTeams}
              setSelectedTeams={setSelectedTeams}
              selectable
            />
          </Grid>
          <div
            onClick={() => {}}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              marginBottom: "20px",
            }}
          >
            <Button
              title="Send Invite"
              type="submit"
              color="primary"
              variant="contained"
              style={{ ...btnStyle, marginRight: "10px" }}
              onClick={async (e) => {
                setIsEnabled(false);
              }}
            >
              Close
            </Button>
            {loading ? (
              <CircularProgress size={20} />
            ) : (
              <Button
                title="Send Invite"
                type="submit"
                color="primary"
                variant="contained"
                style={btnStyle}
                onClick={async (e) => {
                  const patientRepo = PatientRepository.getInstance();
                  try {
                    setLoading(true);

                    await patientRepo.updatePatient(patientId, {
                      teams: selectedTeams.map((item: any) => item._id),
                    });
                    setLoading(false);
                  } catch (error) {
                    setLoading(false);
                  }
                  setIsEnabled(false);
                  setCurrentTeams(selectedTeams.map((item: any) => item._id));
                }}
              >
                Assign
              </Button>
            )}
          </div>
        </>
      </Box>
    </StyledModal>
  );
};
